module.exports = __webpack_public_path__ + "static/media/growth.82c8ac82.svg";